
export const AppMenus = {
    
	navbarTopRight: [],
	navbarTopLeft: [],
	navbarSideLeft: [
  {
    "to": "/pendientes",
    "label": "Mis pendientes",
    "icon": "pi pi-inbox",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/home",
    "label": "Tablero de Solicitudes",
    "icon": "pi pi-home",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/home/quotations",
    "label": "Tablero de Cotizaciones",
    "icon": "pi pi-file",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/request_proposal",
    "label": "Oportunidades de cotización",
    "icon": "pi pi-credit-card",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/projects/salesfunnel",
    "label": "Seguimiento de Ventas",
    "icon": "pi pi-calendar",
    "iconcolor": "",
    "target": "",
  },
  {
    "to": "/projects/semanasmes",
    "label": "Avance y Metas",
    "icon": "pi pi-flag",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "",
    "label": "Seguimiento",
    "icon": "pi pi-angle-double-right",
    "iconcolor": "",
    "target": "",
    "items": [
      {
        "to": "/projects/seguimientoadmin",
        "label": "Cotización",
        "icon": "pi pi-search",
        "iconcolor": "",
        "target": "",
        
      },
    ]
  },
  {
    "to": "",
    "label": "Asistencia",
    "icon": "pi pi-calendar-plus",
    "iconcolor": "",
    "target": "",
    "items": [
      {
        "to": "/dashboard",
        "label": "Dashboard",
        "icon": "pi pi-chart-bar",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/employees",
        "label": "Empleados",
        "icon": "pi pi-users",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/documents/index/applies_to/empleado",
        "label": "Documentos de empleados",
        "icon": "pi pi-id-card",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/attendance-projects",
        "label": "Proyectos",
        "icon": "pi pi-briefcase",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/attendance",
        "label": "Ver asistencias",
        "icon": "pi pi-list",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/vacaciones",
        "label": "Vacaciones",
        "icon": "pi pi-sun",
        "iconcolor": "",
        "target": "",
      },
    ],
  },
  {
    "to": "",
    "label": "Ejecución de Proyectos",
    "icon": "pi pi-sitemap",
    "iconcolor": "",
    "target": "",
    "items": [
      {
        "to": "/project_executions/dashboard_admin",
        "label": "Dashboard (todos)",
        "icon": "pi pi-chart-bar",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/project_executions/dashboard_user",
        "label": "Mi Dashboard",
        "icon": "pi pi-chart-line",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/project_executions/list_admin",
        "label": "Proyectos (todos)",
        "icon": "pi pi-briefcase",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/project_executions/list_user",
        "label": "Mis proyectos",
        "icon": "pi pi-folder-open",
        "iconcolor": "",
        "target": "",
      },
    ],
  },
  {
    "to": "",
    "label": "Comercial",
    "icon": "pi pi-briefcase",
    "iconcolor": "",
    "target": "",
    "items": [
      {
        "to": "/requisiciones",
        "label": "Requisiciones",
        "icon": "pi pi-shopping-cart",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/purchase_orders",
        "label": "Órdenes de Compra",
        "icon": "pi pi-shopping-cart",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/purchase_orders/create_extraordinary",
        "label": "Compra Extraordinaria",
        "icon": "pi pi-plus-circle",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/presupuestos",
        "label": "Presupuesto",
        "icon": "pi pi-calculator",
        "iconcolor": "",
        "target": "",
      },
    ],
  },
  {
    "to": "",
    "label": "Vehículos",
    "icon": "pi pi-car",
    "iconcolor": "",
    "target": "",
    "items": [
      {
        "to": "/vehicles",
        "label": "Lista de vehículos",
        "icon": "pi pi-list",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/vehicle_inspections",
        "label": "Revisiones vehiculares",
        "icon": "pi pi-check-square",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/vehicle_services",
        "label": "Seguimiento de servicio",
        "icon": "pi pi-wrench",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/vehicle_events",
        "label": "Eventos vehiculares",
        "icon": "pi pi-exclamation-triangle",
        "iconcolor": "",
        "target": "",
      },
    ],
  },
  {
    "to": "",
    "label": "Administración",
    "icon": "pi pi-cog",
    "iconcolor": "",
    "target": "",
    "items": [
      {
        "to": "/authtable",
        "label": "Usuarios",
        "icon": "pi pi-users",
        "iconcolor": "",
        "target": "",

      },
      {
        "to": "/clients",
        "label": "Clientes",
        "icon": "pi pi-book",
        "iconcolor": "",
        "target": "",

      },
      {
        "to": "/admin/email_recipients",
        "label": "Destinatarios de correo",
        "icon": "pi pi-envelope",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/project_types",
        "label": "Tipos de proyecto",
        "icon": "pi pi-tags",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/definiciones_alcance",
        "label": "Definiciones de alcance",
        "icon": "pi pi-sitemap",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/unidades",
        "label": "Unidades de medida",
        "icon": "pi pi-box",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/filiales",
        "label": "Filiales / Organizaciones",
        "icon": "pi pi-sitemap",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/vendors",
        "label": "Proveedores",
        "icon": "pi pi-truck",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/documents",
        "label": "Tipos de documento",
        "icon": "pi pi-tags",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/audits",
        "label": "Auditoría",
        "icon": "pi pi-history",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/roles",
        "label": "Roles",
        "icon": "pi pi-shield",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/permissions",
        "label": "Permisos",
        "icon": "pi pi-key",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/modules",
        "label": "Módulos",
        "icon": "pi pi-th-large",
        "iconcolor": "",
        "target": "",
      },
      {
        "to": "/admin/actions",
        "label": "Acciones",
        "icon": "pi pi-cog",
        "iconcolor": "",
        "target": "",
      },
    ]
  },

],

    exportFormats: {
        print: {
			label: 'Print',
            icon: 'pi pi-print',
            type: 'print',
            ext: 'print',
        },
        pdf: {
			label: 'Pdf',
			
            icon: 'pi pi-file-pdf',
            type: 'pdf',
            ext: 'pdf',
        },
        excel: {
			label: 'Excel',
            icon: 'pi pi-file-excel',
            type: 'excel',
            ext: 'xlsx',
        },
        csv: {
			label: 'Csv',
            icon: 'pi pi-table',
            type: 'csv',
            ext: 'csv',
        },
    },
    
}
